export default __webpack_public_path__ + "static/media/login.dceb25f6.svg";